import { usePage } from "@inertiajs/react";
import { ErrorBoundary } from "react-error-boundary";
import QuestionIcon from "@sprout/icons/question.tsx";
import "./survey.scss";
import { IconButton } from "@sprout/icon_button.tsx";
import CloseIcon from "@sprout/icons/close.tsx";
import { useState } from "react";
import axios from "axios";
import { Body, SectionTitle } from "@sprout/typography.tsx";
import useTranslation from "@hooks/use_translation.ts";
import useDevice from "@hooks/use_device.ts";
import { SecondaryButtonLink } from "@sprout/buttons";

interface SurveyProps {
  paths: {
    dismiss: string;
    visit: string;
  };
}

type PageProps = {
  survey?: SurveyProps;
};

export const SurveyCallout = () => {
  const { isMobile } = useDevice();
  const { survey } = usePage<PageProps>().props;
  const { t } = useTranslation("survey");

  const [isVisible, setIsVisible] = useState(!!survey);

  if (!isVisible || !survey) {
    return null;
  }

  const { paths } = survey;

  const handleDismiss = async () => {
    await axios.post(paths.dismiss);

    setIsVisible(false);
  };

  return (
    // Wrap in an error boundary with an empty fallback because the rest of the page
    // shouldn't fail to render if the survey component fails to render.
    <ErrorBoundary fallback={<></>}>
      <div className="survey">
        <QuestionIcon color="green-text" />
        <div className="survey__content">
          <div className="survey__details">
            <SectionTitle>{t("callout.title")}</SectionTitle>
            <Body>{t("callout.body")}</Body>
          </div>
          <SecondaryButtonLink
            href={paths.visit}
            onClick={() => setIsVisible(false)}
            external
            size={isMobile ? "medium" : "large"}
          >
            {t("callout.cta")}
          </SecondaryButtonLink>
        </div>
        <div className="survey__dismiss">
          <IconButton
            label={t("callout.dismiss")}
            icon={CloseIcon}
            size="md"
            onClick={handleDismiss}
          />
        </div>
      </div>
    </ErrorBoundary>
  );
};
